import { render, staticRenderFns } from "./EditBarcode.vue?vue&type=template&id=54e1e432&scoped=true&"
import script from "./EditBarcode.vue?vue&type=script&lang=js&"
export * from "./EditBarcode.vue?vue&type=script&lang=js&"
import style0 from "./EditBarcode.vue?vue&type=style&index=0&id=54e1e432&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e1e432",
  null
  
)

export default component.exports